import { Expose, Transform, Type } from 'class-transformer'
import { Cpu, Truck } from 'react-feather'
import moment from 'moment'

import { Batch } from './Batch'
import { Client } from './Client'
import { Container } from './Container'
import { Place } from './Place'
import { Sku } from './Sku'

export class PalletASN {
  static type = 'asn'
  static typeDisplay = 'ASN'
  static icon = Truck

  type = PalletASN.type
  typeDisplay = PalletASN.typeDisplay
  icon = PalletASN.icon

  @Expose({ name: 'xid' })
  guid?: string

  @Expose({ name: 'tracking_number' })
  trackingNumber?: string

  @Expose({ name: 'bill_of_lading_number' })
  billOfLadingNumber?: string

  @Expose({ name: 'custom_fields' })
  customFields?: Record<string, string>
}

export class Pallet extends Container {
  static type = 'pallet'
  static typeDisplay = 'Pallet'
  static icon = Cpu

  type = Pallet.type
  typeDisplay = Pallet.typeDisplay
  icon = Pallet.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  name: string = ''

  @Expose({ name: 'retired_on' })
  @Transform((value) => (value ? moment(value) : value))
  retiredOn?: moment.Moment

  @Expose({ name: 'retired_from' })
  @Type(() => Place)
  retiredFrom?: moment.Moment

  @Expose({ name: 'is_lost' })
  isLost?: boolean

  @Expose({ name: 'can_delete' })
  canDelete?: boolean

  @Expose({ name: 'can_retire' })
  canRetire?: boolean

  @Expose({ name: 'client_uid' })
  clientID?: string

  @Expose({ name: 'for_shipping' })
  forShipping: boolean = false

  @Expose({ name: 'total_units' })
  totalUnits: number = 0

  @Type(() => Client)
  client?: Client

  @Type(() => Sku)
  skus?: Sku[]

  @Type(() => PalletASN)
  asn?: PalletASN

  @Type(() => Batch)
  batch?: Batch

  @Expose({ name: 'created_on' })
  @Transform((value) => moment(value))
  createdOn: moment.Moment = moment()

  get skuStr() {
    if (!this.skus || !this.skus.length) {
      return ''
    }
    return this.skus.map((sku) => sku.sku).join(', ')
  }
}
